import type { ConversationMessageRole } from './conversationMessageRole';

/**
 * 개별 대화 메시지 정보
 */
export interface ConversationMessage {
  /**
   * 응답 토큰 수
   * @nullable
   */
  completionTokens?: number | null;
  /** 메시지 내용 */
  content: string;
  /**
   * 대화 ID
   * @nullable
   */
  conversationId?: string | null;
  /**
   * 생성 시각
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 메시지 ID
   * @nullable
   */
  id?: string | null;
  /**
   * 사용된 모델 정보
   * @nullable
   */
  model?: string | null;
  /**
   * 프롬프트 토큰 수
   * @nullable
   */
  promptTokens?: number | null;
  /** 메시지 역할 */
  role: ConversationMessageRole;
  /**
   * 총 토큰 수
   * @nullable
   */
  totalTokens?: number | null;
}
